// extracted by mini-css-extract-plugin
module.exports = {"whiteOff":"#F7F7F7","footerHeight":"4.375rem","paginationHeight":"5rem","mobileBreakpoint":"30rem","app":"app_app__lfedb","appPagination":"app_appPagination__103ry app_app__lfedb"};